import $ from 'jquery';
import Rails from '@rails/ujs';
import 'eere-app-template-mea';
import 'bootstrap-datepicker';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/carousel';
import '@/lib/font_awesome_icons';
import '@/cc';
import 'jquery-validation';
import '@/jquery.url-param';
import '@/publication_orders';
import '@/news_events';
import '@/coalitions/search';
import '@/contact_bios';
import '@/projects_and_partnerships/projects';
import '@/projects_and_partnerships/initiatives';

Rails.start();

// jump to an ID/click button when hash included in URL
window.clickHash = function clickHash() {
  if (window.location.hash) {
    $(window.location.hash).trigger("click");
  }
}
